/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
import { Alert, Box, Button, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material';
import InputBooleanFormik from 'components/shared/custom_input_boolean_formik';
import InputComLabelFormik from 'components/shared/custom_input_label_formik';
import { useFormik } from 'formik';
import { FormularioComunidades } from 'interfaces/formularioComunidades.interface';
import React, { useEffect, useState } from 'react';
import { FormComunidadesRuraisHorizontalStepper } from '../form_comunidades_rurais_stepper';
import { validationSchemaComunidades } from './form_comunidades.validate';
import InputSelectFormik from 'components/shared/custom_input_select_formik';

interface FormComunidadesRuraisAdicionarProps {
    formik: any;
    open: boolean;
    setOpen: (open: boolean) => void;
    editValues: any;
    setEditValues: (values: any) => void;
}

export const tiposAssentamento = [
    { value: 3, label: 'FEDERAIS – PA' },
    { value: 4, label: 'FEDERAIS CASULO/PCA (parceria entre INCRA e município)' },
    { value: 5, label: 'ESTADUAIS – PE' },
    { value: 6, label: 'PROJETOS DO TERRA BRASIL/ PROGRAMA NACIONAL DE CRÉDITO FUNDIÁRIO (PNCF)/ BANCO DA TERRA' },
];

export const fontesAgua = [
    { value: 1, label: 'Córrego' },
    { value: 2, label: 'Rio ou outro curso d\'água' },
    { value: 3, label: 'Poço comum' },
    { value: 4, label: 'Poço artesiano ou semi-artesiano' },
    { value: 5, label: 'Captação da chuva' },
    { value: 6, label: 'Água potável de órgão/companhia de abastecimento' },
];

export const tiposCadastro = [
    { value: 1, label: 'Assentamento' },
    { value: 2, label: 'Comunidade Quilombola' },
];

export const jurisdicoes = ['Federal', 'Estadual', 'Municipal'];

const generateUniqueId = () => {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}



export const FormComunidadesRuraisAdicionar:
    React.FC<FormComunidadesRuraisAdicionarProps> = ({ formik, open, setOpen, editValues, setEditValues }) => {
        const [isSubmitting, setIsSubmitting] = useState(true);
        const [clearErrors, setClearErrors] = useState(false);
        const localFormik = useFormik({
            initialValues: {
                unique_id: generateUniqueId(),
                step_atual: 1,
                // step 1
                tipo_cadastro: 0,
                tipo_de_assentamento: 0,
                codigo_do_pa: '',
                nome_do_assentamento: '',
                quantidade_de_familias: 0,
                // step 2
                possui_energia_eletrica: null,
                possui_saneamento_basico: null,
                coleta_de_lixo: null,
                recebeu_manutencao_das_estradas_no_ultimo_ano: null,
                possui_escolas: null,
                quantidade_escolas: 0,
                escolas: [],
                possui_oferta_de_transporte_escolar_para_os_estudantes: null,
                possui_unidade_de_saude: null,
                recebeu_agentes_de_saude_do_municipio: null,
                tem_acesso_internet: null,
                // step 3
                possui_agua_para_abastecimento_domestico: null,
                qual_fonte_da_agua_domestico: 0,
                possui_agua_para_producao_agropecuaria: null,
                qual_fonte_da_producao_agropecuaria: 0,
                quantas_familia_estao_sem_acesso_agua_domestico: 0,
                quantas_familia_estao_sem_acesso_agua_producao: 0,
                comunidade_quilomba_tem_dificil_acesso_agua_domestico: null,
                comunidade_quilomba_tem_dificil_acesso_agua_producao: null,
            } as FormularioComunidades,
            validationSchema: validationSchemaComunidades,
            validateOnChange: !isSubmitting,
            validateOnBlur: !isSubmitting,

            onSubmit: async (values) => {
                const isInvalid = await localFormik.validateForm();
                if (Object.keys(isInvalid).length > 0) {
                    console.log('isInvalid', isInvalid);
                    setIsSubmitting(true);
                    localFormik.setErrors({});
                    return;
                }
                setIsSubmitting(false);
                if (values.step_atual !== 3) {
                    localFormik.setFieldValue('step_atual', values.step_atual + 1);
                    setClearErrors(true);
                    return;
                }

                // se o assentamento ou comunidade ja existe exclui
                const assentamentos = [...formik.values.assentamentos] as any;
                const comunidades = [...formik.values.comunidades] as any;
                const assentamentoExiste = assentamentos.find((assentamento: any) => assentamento.unique_id === values.unique_id);
                const comunidadeExiste = comunidades.find((comunidade: any) => comunidade.unique_id === values.unique_id);
                if (assentamentoExiste) {
                    assentamentos.splice(assentamentos.indexOf(assentamentoExiste), 1);
                }
                if (comunidadeExiste) {
                    comunidades.splice(comunidades.indexOf(comunidadeExiste), 1);
                }

                if (values.tipo_cadastro === 1) {
                    const novoAssentamento = { ...values, unique_id: generateUniqueId() };
                    formik.setFieldValue('assentamentos', [...assentamentos, novoAssentamento]);
                    localFormik.resetForm();
                    setOpen(false);
                    return;
                } else {
                    const novoComunidade = { ...values, unique_id: generateUniqueId() };
                    formik.setFieldValue('comunidades', [...comunidades, novoComunidade]);
                    localFormik.resetForm();
                    setOpen(false);
                    return;
                }


            }
        })

        const isAssentamento = localFormik.values.tipo_cadastro === 1;

        const handleSubmit = async () => {
            setIsSubmitting(false);
            localFormik.handleSubmit();
        }

        const handleCancel = () => {
            if (localFormik.values.step_atual !== 1) {
                localFormik.setFieldValue('step_atual', localFormik.values.step_atual - 1);
                return;
            }
            localFormik.resetForm();
            setOpen(false);
        }

        useEffect(() => {
            if (clearErrors) {
                localFormik.setErrors({});
                setClearErrors(false);
                setIsSubmitting(true);
            }
        }, [localFormik]);

        useEffect(() => {
            const escolas = localFormik.values.escolas;

            if (localFormik.values.quantidade_escolas! > escolas.length) {
                const novasEscolas = [...escolas] as any;
                for (let i = escolas.length; i < localFormik.values.quantidade_escolas!; i++) {
                    novasEscolas.push({
                        nome: '',
                        jurisdicao: '',
                    });
                }
                localFormik.setFieldValue('escolas', novasEscolas);
                return;
            }
            if (localFormik.values.quantidade_escolas! < escolas.length) {
                const novasEscolas = [...escolas] as any;
                novasEscolas.splice(localFormik.values.quantidade_escolas, escolas.length - localFormik.values.quantidade_escolas!);
                localFormik.setFieldValue('escolas', novasEscolas);
                return;
            }
        }, [localFormik.values.quantidade_escolas]);

        useEffect(() => {
            if (editValues) {
                console.log('editValues', editValues);
                localFormik.setValues(editValues as any);
                setEditValues(null);
            }
        }, [editValues]);

        return (
            <>
                <Button
                    variant='contained'
                    color='primary'
                    onClick={() => setOpen(true)}
                    style={{
                        display: open ? 'none' : 'block'
                    }}
                >
                    Adicionar Comunidades Rurais e Tradicionais
                </Button>

                <Box
                    display={open ? 'block' : 'none'}
                >
                    <Box mb={1}>
                        <Typography variant='h6'>
                            Adicionar uma Nova Comunidade
                        </Typography>
                    </Box>
                    <Box>
                        <FormComunidadesRuraisHorizontalStepper
                            activeStep={localFormik.values.step_atual}
                        />
                    </Box>

                    {/* Step 1 */}
                    <Box
                        display={localFormik.values.step_atual === 1 ? 'block' : 'none'}
                    >
                        <Typography variant='h6' mb={2}>
                            Informações Básicas
                        </Typography>

                        <Box>

                            <Alert
                                severity='info'
                                sx={{ marginY: '2rem', backgroundColor: '#EAEFF9' }}
                            >
                                <Typography
                                    variant='body2'
                                    fontSize='16px'
                                    textAlign='left'
                                    lineHeight={1.5}
                                >
                                    {`Escolha o tipo de cadastro que mais representa sua realidade, mesmo que você não tenha certeza do nome oficial.`}
                                </Typography>
                            </Alert>
                            <Grid item xs={12} mb={1}>
                                <InputSelectFormik
                                    formik={localFormik}
                                    label='tipo_cadastro'
                                    labelTexto='Tipo de Cadastro'
                                    required
                                    margin='dense'
                                    options={tiposCadastro.map(tipo => ({
                                        value: tipo.value,
                                        label: tipo.label
                                    }))}
                                />
                            </Grid>
                        </Box>
                        {
                            isAssentamento && (
                                <Box>
                                    <Grid item xs={12} mb={2}>
                                        <InputSelectFormik
                                            formik={localFormik}
                                            label='tipo_de_assentamento'
                                            labelTexto='Tipo de Assentamento'
                                            required
                                            margin='dense'
                                            options={tiposAssentamento.map(tipo => ({
                                                value: tipo.value,
                                                label: tipo.label
                                            }))}
                                        />

                                    </Grid>

                                    <Grid item xs={12} mb={3}>
                                        <InputComLabelFormik
                                            label='codigo_do_pa'
                                            formik={localFormik}
                                            labelTexto='Código do PA'
                                            placeholder='MT0000000'
                                            version='primary'
                                            mask='custom'
                                            customMask={(value: string) => {
                                                // precisa ficar no formato MT00000000
                                                //adicionar o MT no inicio
                                                let valueFormatted = value.replace(/[^0-9]/g, '');
                                                valueFormatted = 'MT' + valueFormatted;
                                                if (valueFormatted.length > 10) {
                                                    return valueFormatted.slice(0, 10);
                                                }
                                                return valueFormatted;
                                            }}
                                            maxLength={10}
                                            required
                                        />
                                    </Grid>


                                </Box>
                            )
                        }

                        <Grid item xs={12} mb={3}>
                            <InputComLabelFormik
                                label='nome_do_assentamento'
                                formik={localFormik}
                                labelTexto='Nome do assentamento/comunidade quilombola'
                                placeholder='Nome do assentamento/comunidade quilombola'
                                version='primary'
                                required
                            />
                        </Grid>

                        <Grid item xs={12} mb={3}>
                            <InputComLabelFormik
                                label='quantidade_de_familias'
                                formik={localFormik}
                                labelTexto='Quantidade de Famílias'
                                version='primary'
                                type='number'
                                required
                                acceptFraction={false}
                            />
                        </Grid>

                    </Box>

                    {/* Step 2 */}
                    <Box
                        display={(localFormik.values.step_atual === 2) ? 'block' : 'none'}
                    >
                        <Box>
                            <Typography variant='h6' mb={2}>
                                Infraestrutura e Serviços
                            </Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={6} mb={3}>
                                    <InputBooleanFormik
                                        label='possui_energia_eletrica'
                                        formik={localFormik}
                                        labelTexto='Possui energia elétrica'
                                    />
                                </Grid>

                                <Grid item xs={6} mb={3}>
                                    <InputBooleanFormik
                                        label='possui_saneamento_basico'
                                        formik={localFormik}
                                        labelTexto='Possui saneamento básico'
                                    />
                                </Grid>
                                <Grid item xs={6} mb={3}>
                                    <InputBooleanFormik
                                        label='coleta_de_lixo'
                                        formik={localFormik}
                                        labelTexto='Coleta de lixo'
                                    />
                                </Grid>
                                <Grid item xs={6} mb={3}>
                                    <InputBooleanFormik
                                        label='recebeu_manutencao_das_estradas_no_ultimo_ano'
                                        formik={localFormik}
                                        labelTexto='Recebeu manutenção das estradas no último ano'
                                    />
                                </Grid>
                                <Grid item xs={6} mb={3}>
                                    <InputBooleanFormik
                                        label='possui_escolas'
                                        formik={localFormik}
                                        labelTexto='Possui escolas'
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2}
                                display={localFormik.values.possui_escolas ? 'block' : 'none'}
                            >
                                <Grid item xs={6} mb={3}>
                                    <Box
                                        sx={{ width: '100%' }} display={'flex'} gap={1} flexDirection={'row'}>
                                        <TextField
                                            id='beneficiarios-exclusivamente-municipio'
                                            label='Quantidade de Escolas'
                                            variant='outlined'
                                            placeholder='Quantidade de Escolas'
                                            type='text'
                                            required
                                            value={localFormik.values.quantidade_escolas}
                                            disabled
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            sx={{
                                                width: '100%',
                                            }}
                                        />

                                        <Button
                                            variant='contained'
                                            color='primary'
                                            onClick={() => {
                                                const novasEscolas = [...localFormik.values.escolas] as any;
                                                novasEscolas.push({ nome: '', jurisdicao: '' });
                                                localFormik.setFieldValue('escolas', novasEscolas);
                                                localFormik.setFieldValue('quantidade_escolas', novasEscolas.length);
                                            }
                                            }
                                            sx={{
                                                width: '100%',
                                                height: '55px',
                                            }}
                                        >
                                            Adicionar Escola</Button>
                                    </Box>


                                </Grid>

                                <Grid item xs={12} mb={3}>
                                    {localFormik.values.escolas.map((escola: any, index: number) => (
                                        <Box key={index} mb={2} p={2} border="1px solid #ddd" borderRadius={1}>
                                            <Typography variant="subtitle1" mb={2}>
                                                Escola {index + 1}
                                            </Typography>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    <InputComLabelFormik
                                                        label={`escolas.${index}.nome`}
                                                        formik={localFormik}
                                                        labelTexto={`Nome da Escola ${index + 1}`}
                                                        placeholder="Digite o nome da escola"
                                                        version='primary'
                                                        required
                                                    />
                                                </Grid>
                                                <Grid item xs={6} display={'flex'} gap={1} flexDirection={'row'}>
                                                    <FormControl fullWidth required error={!!(localFormik.errors.escolas as any)?.[index]?.jurisdicao}>
                                                        <InputLabel>Jurisdição da Escola {index + 1}</InputLabel>
                                                        <Select
                                                            value={escola.jurisdicao || ''}
                                                            onChange={(e: SelectChangeEvent) =>
                                                                localFormik.setFieldValue(`escolas.${index}.jurisdicao`, e.target.value)
                                                            }
                                                            label={`Jurisdição da Escola ${index + 1}`}
                                                            error={!!(localFormik.errors.escolas as any)?.[index]?.jurisdicao}
                                                        >
                                                            {jurisdicoes.map((jurisdicao) => (
                                                                <MenuItem key={jurisdicao} value={jurisdicao}>
                                                                    {jurisdicao}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        {!!(localFormik.errors.escolas as any)?.[index]?.jurisdicao && (
                                                            <FormHelperText error>
                                                                {(localFormik.errors.escolas as any)[index].jurisdicao}
                                                            </FormHelperText>
                                                        )}
                                                    </FormControl>
                                                    {/* botao de remover escola */}
                                                    <Button
                                                        variant='contained'
                                                        color='primary'
                                                        onClick={() => {
                                                            const novasEscolas = [...localFormik.values.escolas] as any;
                                                            novasEscolas.splice(index, 1);
                                                            localFormik.setFieldValue('escolas', novasEscolas);
                                                            localFormik.setFieldValue('quantidade_escolas', novasEscolas.length);
                                                        }
                                                        }
                                                        sx={{
                                                            height: '55px',
                                                        }}
                                                    >
                                                        Remover Escola</Button>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    ))}
                                </Grid>
                            </Grid>

                            <Grid container spacing={2}>
                                <Grid item xs={6} mb={3}>
                                    <InputBooleanFormik
                                        label='possui_oferta_de_transporte_escolar_para_os_estudantes'
                                        formik={localFormik}
                                        labelTexto='Possui oferta de transporte escolar para os estudantes'
                                    />
                                </Grid>
                                <Grid item xs={6} mb={3}>
                                    <InputBooleanFormik
                                        label='possui_unidade_de_saude'
                                        formik={localFormik}
                                        labelTexto='Possui unidade de saúde'
                                    />
                                </Grid>
                                <Grid item xs={6} mb={3}>
                                    <InputBooleanFormik
                                        label='recebeu_agentes_de_saude_do_municipio'
                                        formik={localFormik}
                                        labelTexto='Recebeu agentes de saúde do município'
                                    />
                                </Grid>
                                <Grid item xs={6} mb={3}>
                                    <InputBooleanFormik
                                        label='tem_acesso_internet'
                                        formik={localFormik}
                                        labelTexto='Tem acesso à internet'
                                    />
                                </Grid>
                            </Grid>

                        </Box>
                    </Box>


                    {/* Step 3 */}
                    <Box
                        display={(localFormik.values.step_atual === 3) ? 'block' : 'none'}
                    >
                        <Box>
                            <Typography variant='h6' mb={2}>
                                Informações de Água
                            </Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={12} mb={3}>
                                    <InputBooleanFormik
                                        label='possui_agua_para_abastecimento_domestico'
                                        formik={localFormik}
                                        labelTexto='Possui água para abastecimento doméstico'
                                    />
                                </Grid>
                                <Grid item xs={12} mb={1} display={localFormik.values.possui_agua_para_abastecimento_domestico ? 'block' : 'none'}>
                                    <InputSelectFormik
                                        formik={localFormik}
                                        label='qual_fonte_da_agua_domestico'
                                        labelTexto='Qual fonte da água doméstica?'
                                        required
                                        margin='dense'
                                        options={fontesAgua.map(fonte => ({
                                            value: fonte.value,
                                            label: fonte.label
                                        }))}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2}>
                                <Grid item xs={12} mb={3}>
                                    <InputBooleanFormik
                                        label='possui_agua_para_producao_agropecuaria'
                                        formik={localFormik}
                                        labelTexto='Possui água para produção agropecuária'
                                    />
                                </Grid>
                                <Grid item xs={12} mb={1} display={localFormik.values.possui_agua_para_producao_agropecuaria ? 'block' : 'none'}>
                                    <InputSelectFormik
                                        formik={localFormik}
                                        label='qual_fonte_da_producao_agropecuaria'
                                        labelTexto='Qual fonte da água para produção agropecuária?'
                                        required
                                        margin='dense'
                                        options={fontesAgua.map(fonte => ({
                                            value: fonte.value,
                                            label: fonte.label
                                        }))}
                                    />
                                </Grid>
                            </Grid>


                            <Box display={localFormik.values.tipo_cadastro === 1 ? 'block' : 'none'}>
                                <Grid container spacing={2} my={2}>
                                    <Grid item xs={6}>
                                        <InputComLabelFormik
                                            label='quantas_familia_estao_sem_acesso_agua_domestico'
                                            formik={localFormik}
                                            labelTexto='Quantas famílias estão sem acesso à água doméstica?'
                                            version='primary'
                                            type='number'
                                            acceptFraction={false}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={6} mb={3}>
                                        <InputComLabelFormik
                                            label='quantas_familia_estao_sem_acesso_agua_producao'
                                            formik={localFormik}
                                            labelTexto='Quantas famílias estão sem acesso ou com acesso precário à água para produção?'
                                            version='primary'
                                            type='number'
                                            acceptFraction={false}
                                            required
                                        />
                                    </Grid>
                                </Grid>

                            </Box>


                            <Box display={localFormik.values.tipo_cadastro === 2 ? 'block' : 'none'}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} mb={3}>
                                        <InputBooleanFormik
                                            label='comunidade_quilomba_tem_dificil_acesso_agua_domestico'
                                            formik={localFormik}
                                            labelTexto='A comunidade quilombola tem dificuldade de acesso à água doméstica?'

                                        />
                                    </Grid>
                                    <Grid item xs={12} mb={3}>
                                        <InputBooleanFormik
                                            label='comunidade_quilomba_tem_dificil_acesso_agua_producao'
                                            formik={localFormik}
                                            labelTexto='A comunidade quilombola tem dificuldade de acesso à água para produção agropecuária?'
                                        />
                                    </Grid>
                                </Grid>

                            </Box>


                        </Box>
                    </Box>



                    <Box display={'flex'} gap={1} justifyContent={'flex-end'}>
                        <Button
                            variant='outlined'
                            color='primary'
                            onClick={handleCancel}
                        >
                            {
                                localFormik.values.step_atual !== 1 ? 'Voltar' : 'Cancelar'
                            }
                        </Button>
                        <Button
                            variant='contained'
                            color='primary'
                            onClick={handleSubmit}
                        >
                            {
                                localFormik.values.step_atual !== 3 ? 'Próximo' : 'Adicionar'
                            }
                        </Button>

                    </Box>
                </Box>
            </>
        )
    }
